// extracted by mini-css-extract-plugin
module.exports = {"stickyIntro":"page_stickyIntro__W2lAG"};